import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M0 6C0 3.79086 1.79086 2 4 2H20C22.2091 2 24 3.79086 24 6V18C24 20.2091 22.2091 22 20 22H4C1.79086 22 0 20.2091 0 18V6Z"
      fill="#D11D1D"
    />
    <path d="M16 12L10 15.4641V8.5359L16 12Z" fill="white" />
  </svg>
);
